<template>
  <div class="weiVCon videoD">
    <div
      v-if="isHasdata"
      class="costListBox"
    >
      <div
        class="costItem"
        v-for="item in orderList"
        :key="item.index"
      >
        <dl class="costTop flexS">
          <dd>订单号:{{item.number}}</dd>
          <dd>时间:{{item.create_time}}</dd>
        </dl>
        <div class="clearfix">
          <img
            src="../assets/imgs/orderIcon.png"
            alt=""
            class="fl orderIcon"
          >
          <div class="fl  orderInfo">
            <dl class="flexS">
              <dd>{{item.title}}</dd>
              <dd class="money">￥{{item.money}}</dd>
            </dl>
            <dl class="flexS">
              <dd
                class="way"
                v-if="item.from === 0"
              >支付方式:支付宝</dd>
              <dd
                class="way"
                v-else-if="item.from ===1"
              >支付方式:微信</dd>
              <dd
                class="way"
                v-else
              >支付方式:--</dd>
              <dd class="success">付款成功</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="noData"
    >
      <img
        src="../assets/imgs/noDataIcon.png"
        alt=""
      >
      <p class="noDataTit">未查询到相关数据</p>
      <p>暂无数据，请刷新重试</p>
    </div>

  </div>
</template>
<script>
import { Indicator } from 'mint-ui'
import { getOrderList } from '../../src/api/Api'
export default {
  name: 'videoD',
  data () {
    return {
      isHasdata: true,
      order: {
        num: '121212212',
        time: '2019-09-12 23:23:12',
        title: '继续教育',
        way: '微信',
        money: '0.01',
        state: '交易失败'
      },
      orderList: []
    }
  },
  created () {
    this.getOrderList()
  },
  mounted () {},
  methods: {
    getOrderList () {
      Indicator.open()
      var _this = this
      getOrderList().then(res => {
        if (res.data.returnCode === 1) {
          this.isHasdata = true
          Indicator.close()
          _this.orderList = res.data.returnDate
          if (res.data.returnDate.length < 1) {
            this.isHasdata = false
          }
        } else {
          Indicator.close()
          this.isHasdata = false
        }
      })
    }
  },
  destroyed () {
    Indicator.close()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/CostList.vue